import { makeStyles } from '@material-ui/core/styles';

import { launchmetricsGrey } from 'Styles/theme';

export const LANDSCAPE_WIDTH = 500;
export const PORTRAIT_WIDTH = 215;

export const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		alignItems: 'flex-start',
		flexWrap: 'wrap'
	},
	rootMobile: {
		flexDirection: 'row'
	},
	mediaColumn: {
		flexBasis: '45%',
		flexGrow: 0
	},
	mediaColumnMobile: {
		flexBasis: '100%',
		flexGrow: 1,
		maxWidth: '100%'
	},
	mediaColumnInner: {
		position: 'relative',
		maxWidth: '100%',
		display: 'inline-block'
	},
	mediaColumnPortraitInner: {
		width: PORTRAIT_WIDTH
	},
	mediaColumnLandscapeInner: {
		width: LANDSCAPE_WIDTH
	},
	mediaActionsContainer: {
		position: 'absolute',
		top: 10,
		right: 10
	},
	mediaImg: {
		width: '100%'
	},
	textColumn: {
		flex: 1
	},
	textColumnMobile: {
		marginTop: 30
	},
	textColumnInner: {
		display: 'flex',
		maxWidth: 560,
		flexDirection: 'column',
		paddingTop: 20
	},
	textColumnInnerMobile: {
		maxWidth: '100%',
		paddingTop: 0
	},
	title: {
		fontSize: 22,
		marginBottom: 30
	},
	titleMobile: {
		fontSize: 18,
		marginBottom: 15
	},
	textWrapper: {
		fontSize: 14,
		lineHeight: '22px'
	},
	popper: {
		top: '5px !important'
	},
	popperContent: {
		padding: '4.5px 16px 3.5px',
		color: 'white',
		fontSize: 12,
		lineHeight: '20px',
		background: launchmetricsGrey,
		borderRadius: 3,
		maxWidth: 180
	}
}));
